import { render, staticRenderFns } from "./UserRegistrationPage.vue?vue&type=template&id=72ae5db4&scoped=true"
import script from "./UserRegistrationPage.vue?vue&type=script&lang=js"
export * from "./UserRegistrationPage.vue?vue&type=script&lang=js"
import style0 from "./UserRegistrationPage.vue?vue&type=style&index=0&id=72ae5db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ae5db4",
  null
  
)

export default component.exports